import { ShieldAlert } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';

import { StatusPage } from './status-page';

/**
 * Access Denied for a page the signed-in user's permissions do not cover.
 * The user stays signed in; "Back to home" goes through `/`, which lands them
 * on the first screen they are permitted to see.
 */
export function ForbiddenPage() {
  return (
    <StatusPage
      icon={ShieldAlert}
      code="403"
      title="You do not have access to this page"
      description="Your account is signed in, but its role does not include this area. If you believe this is wrong, ask an administrator to review your permissions."
      actions={
        <Button asChild variant="outline" size="sm">
          <Link to="/">Back to home</Link>
        </Button>
      }
    />
  );
}
